import { Menu, MenuItem, Stack, styled } from '@mui/material'
import { MouseEvent, ReactElement, ReactNode, useState } from 'react'
import { TextButtonProps } from './TextButton'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { Typography } from '../../text'
import { TextButtonNew } from 'ComponentLibrary/src/piazza/buttons'

export type Option = {
    title: string
    callback: () => void
    icon?: ReactNode
}

type TextButtonWithOptionsProps = {
    options: Option[]
    leftIcon?: ReactElement
    rightIcon?: ReactElement
} & Omit<TextButtonProps, 'onClick'>

export function TextButtonWithOptions({ options, leftIcon, rightIcon, ...textButtonProps }: TextButtonWithOptionsProps) {
    const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>()

    const onClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const onClose = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        setAnchorEl(undefined)
    }

    return (
        <>
            <TextButtonNew onClick={onClick} {...textButtonProps} leftIcon={leftIcon} rightIcon={rightIcon} />
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onClose}>
                {options.map((option) => (
                    <StyledMenuItem
                        key={`menu-item-${option.title}`}
                        onClick={(event) => {
                            event.stopPropagation()
                            option.callback()
                            setAnchorEl(undefined)
                        }}
                        disableRipple
                    >
                        <Stack direction="row" gap={tokens.SizingSpacing075} alignItems="center">
                            {option.icon}
                            <Typography variant="textM">{option.title}</Typography>
                        </Stack>
                    </StyledMenuItem>
                ))}
            </Menu>
        </>
    )
}

const StyledMenuItem = styled(MenuItem)(() => ({
    minHeight: 'auto',
    padding: '9px 16px',
}))
